import { render, staticRenderFns } from "./ForbiddenPage.vue?vue&type=template&id=d549917c&scoped=true&"
var script = {}
import style0 from "./ForbiddenPage.vue?vue&type=style&index=0&id=d549917c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d549917c",
  null
  
)

export default component.exports